import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [mode, setMode] = useState('email'); // 'email' | 'pin'
  const [form, setForm] = useState({ email: '', password: '', pin_code: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const credentials = mode === 'email'
        ? { email: form.email, password: form.password }
        : { pin_code: form.pin_code };

      const user = await login(credentials);

      // Redirigir según rol
      if (user.role.level >= 90) navigate('/admin/dashboard');
      else if (user.role.level >= 70) navigate('/admin/dashboard');
      else if (user.role.slug === 'chef') navigate('/kitchen');
      else if (user.role.slug === 'cashier') navigate('/cashier');
      else if (user.role.slug === 'waiter') navigate('/waiter');
      else navigate('/');

    } catch (err) {
      setError(err.response?.data?.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
      padding: '20px',
    }}>
      <div className="card" style={{ width: '100%', maxWidth: 420, textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 10 }}>🍽️</div>
        <h1 style={{ color: '#38bdf8', marginBottom: 4, fontSize: 24 }}>Restaurant AR</h1>
        <p style={{ color: '#94a3b8', marginBottom: 30, fontSize: 14 }}>Sistema de Gestión Gastronómica</p>

        {/* Toggle modo */}
        <div style={{
          display: 'flex',
          gap: 8,
          marginBottom: 24,
          background: '#0f172a',
          padding: 4,
          borderRadius: 10,
        }}>
          <button
            onClick={() => setMode('email')}
            style={{
              flex: 1,
              padding: '10px',
              borderRadius: 8,
              border: 'none',
              background: mode === 'email' ? '#38bdf8' : 'transparent',
              color: mode === 'email' ? '#0f172a' : '#94a3b8',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            Email
          </button>
          <button
            onClick={() => setMode('pin')}
            style={{
              flex: 1,
              padding: '10px',
              borderRadius: 8,
              border: 'none',
              background: mode === 'pin' ? '#38bdf8' : 'transparent',
              color: mode === 'pin' ? '#0f172a' : '#94a3b8',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            PIN Rápido
          </button>
        </div>

        {error && (
          <div style={{
            background: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid #ef4444',
            color: '#ef4444',
            padding: '12px',
            borderRadius: 10,
            marginBottom: 20,
            fontSize: 14,
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {mode === 'email' ? (
            <>
              <input
                type="email"
                placeholder="Correo electrónico"
                className="input"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                style={{ marginBottom: 12 }}
                required
              />
              <input
                type="password"
                placeholder="Contraseña"
                className="input"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                style={{ marginBottom: 20 }}
                required
              />
            </>
          ) : (
            <input
              type="password"
              placeholder="Ingresa tu PIN"
              className="input"
              value={form.pin_code}
              onChange={(e) => setForm({ ...form, pin_code: e.target.value })}
              style={{ marginBottom: 20, fontSize: 24, textAlign: 'center', letterSpacing: 8 }}
              maxLength={10}
              required
            />
          )}

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', padding: 14, fontSize: 16 }}
            disabled={loading}
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        <p style={{ color: '#64748b', marginTop: 20, fontSize: 12 }}>
          ¿Eres cliente? <a href="/menu/SUC-001" style={{ color: '#38bdf8' }}>Ver menú digital</a>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
